import axios from "axios";
import _ from 'lodash';

const state = {
	abuses: {
		data: [],
		meta: {
			// PAGINATION
			current_page: null,
			from: null,
			last_page: null,
			links: null,
			path: null,
			per_page: null,
			to: null,
			total: null,
		}
	}
};

const getters = {
	abuses: (state) => {
		return state.abuses.data;
	},
	meta: (state) => {
		return state.abuses.meta;
	}
};

const mutations = {
	setAbuses(state, payload) {
		console.log("SET ABUSES", payload)
		state.abuses.data = payload;
	},
	setMeta(state, payload) {
		state.abuses.meta = payload;
	},
	setAbuse(state, payload) {
		let idx = state.abuses.data.findIndex(x => x.id == payload.id);
		console.log("SET ABUSE ID INDEX", idx) 
		if(idx != -1) {
			let n = _.merge({}, state.abuses.data[idx], payload)
			state.abuses.data.splice(idx, 1, n);
			state.abuses.data[idx] = payload;
			return true;
		}
		return false;
	},
	removeAbuse(state, payload) {
		let idx = state.abuses.data.findIndex(x => x.id == payload.id);
		console.log("REMOVE ABUSE ID INDEX", idx) 
		if(idx != -1) {
			state.abuses.data.splice(idx, 1);
			return true;
		}
		return false;
	}

}

const actions = {
	async getAbuses({commit}, params) {
		let res = {};
		await axios.get('abuses', {
			params: params
		})
		.then(response => {
			console.log("SUCCESS GETTING ABUSES", response)
			commit('setAbuses', response.data.data);
			commit('setMeta', response.data.meta);
			res = {
				success: true,
				data: response.data.data,
				meta: response.data.meta,
				error: false
			}
		})
		.catch(error => {
			console.log("ERROR GETTING ABUSES")
			res = {
				success: false,
				data: null,
				meta: null,
				error: error
			}
		})
		return res;
	},
	/* eslint-disable */
	async consideAbuse({commit}, payload) {
		let res = {};
		await axios.post('abuses/' + payload.id, {
			status: payload.status
		})
		.then(response => {
			console.log("CONSIDE ABUSE SUCCESS", response);
			res = {
				success: true,
				data: response.data.data,
				error: false
			}
		})
		.catch(error => {
			console.log("CONSIDE ABUSE ERROR", error.response);
			res = {
				success: false,
				data: null,
				error: error
			}
		})
		return res;
	}
	/* eslint-enable */
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
